export const dropShadow = {
    primary: `0px 4px 4px 0px rgba(0,0,0, 0.25)` 
};
  